import { render, staticRenderFns } from "./parametrics.vue?vue&type=template&id=5a259493&scoped=true"
import script from "./parametrics.vue?vue&type=script&lang=js"
export * from "./parametrics.vue?vue&type=script&lang=js"
import style0 from "./parametrics.vue?vue&type=style&index=0&id=5a259493&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a259493",
  null
  
)

export default component.exports